import { Link, NavLink, Outlet } from "react-router-dom";
import { theme } from "antd";
import SiteFooter from "../common/SiteFooter.js";
import "./PublicSite.css";

export default function PublicLayout() {
  const { token } = theme.useToken();
  return (
    <div className="public-site" style={{
      "--page-background": token.colorBgLayout,
      "--surface": token.colorBgContainer,
      "--accent": token.colorPrimary,
      "--accent-hover": token.colorPrimaryHover,
      "--accent-soft": token.colorPrimaryBg,
      "--border": token.colorBorder,
      "--muted": token.colorTextSecondary,
    }}>
      <a className="public-skip-link" href="#main-content">Skip to content</a>
      <header className="public-header">
        <Link className="public-brand" to="/" aria-label="Age of Companies home">
          <img src="/logo-small.png" alt="" width="44" height="44" />
          <span>Age of Companies</span>
        </Link>
        <span className="public-tagline">A free multiplayer business simulation</span>
        <nav className="public-nav" aria-label="Public navigation">
          <NavLink to="/about">About the game</NavLink>
          <NavLink to="/patch-notes">Patch notes</NavLink>
        </nav>
      </header>
      <div className="public-page">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
